<template>
    <div class="content">
        <h1>Projekte</h1>
        <div class="configurator--projects panel">
            <div class="panel--filter">
                <div class="panel--status">
                    <label v-for="(status, sKey) in settings.status" :key="sKey">
                        <input type="radio" name="status-filter" class="project--status-filter" v-model="statusFilter"
                               :value="sKey">
                        <span class="badge" :class="sKey" @click="clearStatusFilter($event, sKey)">{{status}}</span>
                    </label>
                </div>
                <div class="panel--actions">
                    <div class="panel--order">
                        <select v-model="order">
                            <option value="position">Eigene Sortierung</option>
                            <option value="title">Titel aufsteigend</option>
                            <option value="-title">Titel absteigend</option>
                            <option value="createDate">Datum aufsteigend</option>
                            <option value="-createDate">Datum absteigend</option>
                        </select>
                    </div>
                    <div class="panel--search">
                        <input type="text" v-model="projectSearch" placeholder="Suchen ..."/>
                    </div>
                </div>
            </div>

            <draggable :list="sProjects" group="people" @start="drag=true" @end="drag=false" @sort="sortProjects"
                       handle=".handle">
                <div v-for="(project, pIndex) in sProjects" :key="pIndex" :class="['row', filterProject(project)]">
                    <div class="cell title">
                        <router-link :to="{ name: 'project', params: { projectId: project.id }}" class="project--title"
                                     v-html="highlightSearch(project.title)"></router-link>
                    </div>
                    <div class="cell actions">
                        <div class="project--create">
                            Erstellt: {{project.createUser}}, {{project.createDate}}
                            <template v-if="project.updateDate">Bearbeitet: {{project.updateUser}},
                                {{project.updateDate}}
                            </template>
                        </div>
                        <span class="badge" :class="project.status"><fa v-if="typeof project.locked === 'string'" icon="lock"></fa> {{settings.status[project.status]}}</span>
                        <div class="action action--edit">
                            <router-link :to="{ name: 'project', params: { projectId: project.id }}">
                                <fa icon="edit"></fa>
                            </router-link>
                        </div>
                        <div class="action action--pdf">
                            <fa icon="file-pdf" @click="openPdf(project.id)"></fa>
                        </div>
                        <div class="action action--duplicate">
                            <fa icon="copy" @click="duplicateProject(project.id)"></fa>
                        </div>
                        <div class="action action--delete">
                            <fa icon="trash" @click="deleteProject(project.id)"></fa>
                        </div>

                        <div class="action action--move" v-if="order === 'position'">
                            <fa icon="arrows-alt" class="handle"></fa>
                        </div>
                    </div>
                </div>
            </draggable>
        </div>

    </div>
</template>

<script>
    let rowOdd = false; // Imutable row Counter
    import draggable from 'vuedraggable'

    export default {
        name: 'home',
        components: {draggable},
        props: ['settings', 'projects'],
        data() {
            return {
                projectSearch: '',
                statusFilter: '',
                sorting: '',
                'order': 'position'
            }
        },
        async created() {
            let me = this;

            await me.$parent.loadProjects();
        },
        methods: {
            deleteProject: function (id) {
                let me = this;

                me.$modal.show('dialog', {
                    title: 'Projekt löschen?',
                    text: 'Bist du dir sicher das du das Projekt löschen möchtest? Nach dem Löschen kann das Projekt nicht wiederhergestellt werden.',
                    buttons: [
                        {
                            title: 'NEIN, nicht löschen',
                            default: true,
                        },
                        {
                            title: 'JA, löschen',
                            class: 'vue-dialog-button delete',
                            handler: () => {
                                me.$modal.hide('dialog');
                                me.$http.delete('/data/projects/' + id).then(function (r) {
                                    let response = r.data;

                                    if (response.projects) {
                                        me.$set(me.$parent, 'projects', response.projects);
                                    }

                                    me.$notify({
                                        text: r.data.msg,
                                        type: r.data.msgType
                                    });
                                });
                            }
                        }
                    ]
                });
            },
            sortProjects: function () {
                let me = this;

                me.sorting = true;

                me.$http.put('/data/projects', me.projects).then(function (r) {
                    me.sorting = false;
                    me.$notify({
                        text: r.data.msg,
                        type: r.data.msgType
                    });
                });
            },
            duplicateProject: function (id) {
                let me = this;

                me.$http.post('/data/projects/' + id).then(function (r) {
                    let response = r.data;

                    if (response.projects) {
                        me.$set(me.$parent, 'projects', response.projects);
                        me.$router.push({name: 'project', params: {projectId: response.newId}});
                        me.$notify({
                            text: response.msg,
                            type: response.msgType
                        });
                    } else {
                        me.$notify({
                            text: response.msg,
                            type: 'error',
                            duration: -1
                        });
                    }
                });
            },
            filterProject: function (project) {
                let me = this,
                    filter,
                    rowClassObject = {
                        filtered: false,
                        odd: false
                    };

                if (me.statusFilter) {
                    filter = project.status !== me.statusFilter;
                } else {
                    filter = project.status === 'reject';
                }
                if (me.projectSearch && (!filter || !me.statusFilter ) ) {
                    filter = !(
                        project.title.toLowerCase().includes(me.projectSearch.toLowerCase())
                        || project.address.toLowerCase().includes(me.projectSearch.toLowerCase())
                    );
                }

                rowClassObject.filtered = filter;

                if ( !filter ) {
                    rowClassObject.odd = rowOdd;
                    rowOdd = !rowOdd;
                }

                return rowClassObject;
            },
            highlightSearch: function (content) {
                let me = this;
                if (!me.projectSearch) {
                    return content;
                }

                return content.replace(new RegExp(me.projectSearch, "gi"), match => {
                    return '<span class="highlight-search">' + match + '</span>';
                });
            },
            clearStatusFilter: function (e, val) {
                let me = this;

                if (me.statusFilter === val) {
                    e.preventDefault();
                    me.statusFilter = '';
                }
            },
            openPdf: function (id) {
                window.open('/data/makepdf.php?id=' + id);
            }
        },
        computed: {
            sProjects: function() {
                let me = this,
                    projects = JSON.parse(JSON.stringify(me.projects));

                if ( me.order !== 'position' ) {
                    projects.sort(me.dynamicSort(me.order));
                }

                return projects;
            }
        },
        updated: function () {
            this.$nextTick(function () {
                rowOdd = false;
            })
        }
    }
</script>